import React from 'react';
// import HubspotForm from "../../components/reusableElementsComponents/HubspotForm";
// import * as Constants from '../../constants'
import { useLocation } from 'react-router-dom';
import { t } from '../../content';
function HelpCenter() {

    const location = useLocation();
    const currentURL = location.pathname;
    
  return currentURL === "/faq-page" ? 
    (
        <div className='center-content'>
            <div className="mar-25 top">
                <h3>{t('help.getInTouch')}</h3>
            </div>
            <br/>
            <p>{t('help.contactBody')} <b>{t('help.contactEmail')}</b></p>
            <p>{t('help.lookForward')}</p>
            {/* <div style={{width: "50%"}}>
                <HubspotForm
                    portalId={Constants.HUBSPOT_PORTAL_ID}
                    formId={Constants.HUBSPOT_CONTACT_USE_FORM_ID}
                    target='helpCenterHbForm'
                />
            </div> */}
        </div>
    ) : (
        <div className="help-center center-content">
            <div className="mar-25 top">
                <h3>{t('help.getInTouch')}</h3>
            </div>
            <br/>
            <p>{t('help.contactBody')} <b>{t('help.contactEmail')}</b></p>
            <p>{t('help.lookForward')}</p>
            {/* <HubspotForm
                portalId={Constants.HUBSPOT_PORTAL_ID}
                formId={Constants.HUBSPOT_CONTACT_USE_FORM_ID}
                target='helpCenterHbForm'
            /> */}
            <br/>
            <div className='onboarding-page'>
                <div className="onboarding-page-wrapper">
                    <div className="copy">
                        <h3>{t('help.whyTrust')}</h3>
                        <p className="m">
                            {t('help.whyTrustBody')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )

}
export default HelpCenter
